import { ICheckoutRecurringPayment } from './checkout-recurring-payment.model';

export interface IMinProductCost {
  minCost: number;
  translationKey: string;
  recurring?: ICheckoutRecurringPayment;
  guestPerQuantity?: number;
}

export const CEmptyMinProductCost: IMinProductCost = {
  minCost: 0,
  translationKey: ''
};
